import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId, PolicySubscriptionId } from '../../types/api/primaryKeys/PrimaryKey';
import { EnrollmentTokenResult } from '../../types/api/harmony/EnrollmentTokenResult';
import { HarmonyPolicyPlanSummary } from '../../types/api/harmony/HarmonyPolicyPlanSummary';
import { HarmonyProductGroup } from '../../types/thirdParty/harmony/HarmonyProductGroup';

/**
 * Retrieves a Harmony enrollment token for the specified package.
 * @param enrollmentPackageId 
 */
export async function fetchHarmonyEnrollmentTokenForPackage(enrollmentPackageId: EnrollmentPackageId) {
	const result = await ApiRequest.get<EnrollmentTokenResult>(`packages/${enrollmentPackageId}/harmony/enrollment-token`);
	return result;
}

export async function updateElectionResults(enrollmentPackageId: EnrollmentPackageId, enrollmentTokenId: string, harmonyProductGroup: HarmonyProductGroup) {
	const result = await ApiRequest.post(`packages/${enrollmentPackageId}/harmony/enrollment-token/${enrollmentTokenId}/${harmonyProductGroup}/update-elections`);
	return result;
}

export async function updateAllElections(enrollmentPackageId: EnrollmentPackageId, enrollmentTokenId: string, harmonyProductGroups: string[]) {
	const result = await ApiRequest.post(`packages/${enrollmentPackageId}/harmony/enrollment-token/${enrollmentTokenId}/all-elections`, harmonyProductGroups);
	return result;
}

export async function getHarmonyPolicyPlanInfo(enrollmentPackageId: EnrollmentPackageId, policySubscriptionId: PolicySubscriptionId) {
	const result = await ApiRequest.get<HarmonyPolicyPlanSummary[]>(`packages/${enrollmentPackageId}/harmony/policy/${policySubscriptionId}/plans`);
	return result;
}